import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UploadTestCenterUsersService } from "src/app/shared";
import Swal from "sweetalert2";
import { first } from "rxjs/operators";

@Component({
  selector: "app-upload-test-center-user-list",
  templateUrl: "./upload-test-center-user-list.component.html",
  styleUrls: ["./upload-test-center-user-list.component.scss"]
})
export class UploadTestCenterUserListComponent implements OnInit {
  filter: any = {
    key: ""
  };
  sender = "UploadTestCenterUserListComponent";
  userCount: any;
  user: any;
  /*** for paginaton start */
  pageSize = 25;
  currentPage = 1;
  examcenterCount = 0;
  doc: any;
  downloadurl = "";
  /** end pagination */

  constructor(
    private router: Router,
    private uploaltestcenterusersservice: UploadTestCenterUsersService
  ) { }

  ngOnInit() {
    this.searchUploadTestCenterUserList();
  }

  uploadUsers() {
    this.router.navigate(["manager/upload-test-center-user/new"]);
  }

  searchUploadTestCenterUserList() {
    this.uploaltestcenterusersservice
      .searchTestCenterUserList(this.currentPage, this.pageSize, this.filter)
      .pipe(first())
      .subscribe(res => {
        this.userCount = res["count"];
        this.user = res["data"];
      });
  }

  fetchUserData(e) {
    this.currentPage = e;
    this.searchUploadTestCenterUserList();
  }

  onAdd() {
    this.router.navigate(["manager/testcenter/new"]);
  }

  onEdit(id) {
    this.router.navigate(["manager/testcenter/" + id]);
  }

  clear() {
    this.filter.key = "";
    this.searchUploadTestCenterUserList();
  }

  onSendPassAll() {
    Swal.fire({
      title: "Are you sure?",
      text:
        "Everyone will be sent their passwords. This is a bulk action.  It will take few minutes to complete. ",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, send now!",
      cancelButtonText: "No, I will do it at test center/individual level"
    }).then(result => {
      if (result.value) {

        this.yesResetAll();
      }
    });
  }

  yesResetAll() {
    this.uploaltestcenterusersservice
      .resetAllPassword({})
      .subscribe(res => {
        Swal.fire("All Done!", "Passwords have been sent to everyone. If someone did not receive, check accuracy of phone number and individually send the password.", "success");
      });
  }


  onDelete() {
    Swal.fire({
      title: "Are you sure?",
      text:
        "Test Center User data will be deleted. This action can't be reversed!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(result => {
      if (result.value) {
        Swal.fire("Deleted!", "Test Center User is deleted.", "success");
        this.uploaltestcenterusersservice
          .deleteAll(this.user)
          .pipe(first())
          .subscribe(res => {
            this.searchUploadTestCenterUserList();
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Test Center User is Not Deleted:)", "error");
      }
    });
  }
}
